import * as Panels from '../../util/panels';
import React from 'react';
import {ParameterImportanceConfig} from './common';
import * as Query from '../../util/queryts';
import {toRunsDataQuery, RunsDataQuery} from '../../containers/RunsDataLoader';

const PANEL_TYPE = 'Parameter Importance';

function transformQuery(query: Query.Query, config: any): RunsDataQuery {
  const result = toRunsDataQuery(
    query,
    {selectionsAsFilters: true},
    {fullConfig: true, fullSummary: true}
  );
  return result;
}

export const Spec: Panels.PanelSpec<
  typeof PANEL_TYPE,
  ParameterImportanceConfig
> = {
  type: PANEL_TYPE,
  Component: React.lazy(() => import('./Component')),
  transformQuery,
  noEditMode: true,
  icon: 'panel-importance',
};
